<template>
  <div class="container-fluid current-sale-line">
    <div class="row">
      <div class="line-description-pane col-5">
        <h6 class="line-description">
          {{ $utils.toPascalCase($utils.cutLength(sale.Description, 30)) }}<br>
        </h6>
        <h5 class="text-success text-sm " v-if="sale.Discount>0">{{ `Discount ${$utils.formatMoney(saleLine.Discount)}` }}</h5>
      </div>
      <div class="d-flex flex-column justify-content-between line-prices-pane col-7">
        <div class="price-row">
          <p class="price-label mx-2">Item Price: <span
              class="line-price">{{ $utils.formatMoney(sale.Unit / rate, 2, '.', ',', true,symbol) }}</span></p>
          <p class="price-label">Total: <span
              class="line-price">{{ $utils.formatMoney(((sale.Unit * sale.Qty ) - sale.Discount + instructionTotal) / rate, 2, '.', ',', true,symbol) }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <ul class="cooking-instruction-list" v-if="hasInstructions">
        <li class="cooking-instruction-list-item" v-for="instruction in instructions">
          {{ instruction.CookingMsg }} <span>{{ instruction.count }} X {{
            $utils.formatMoney(instruction.Price / rate, '.', ',', true,symbol)
          }}</span>
          Total: {{ $utils.formatMoney(instruction.count * instruction.Price / rate, '.', ',', true,symbol) }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ForeignCurrencySaleLine',
  props: {
    sale: {
      type: Object,
      required : true,
    },
    rate : {
      type: Number,
      required : true,
    },
    symbol : {
      type: String,
      required : true,
    },
  },
  computed: {
    hasInstructions() {
      return (this.sale.instructions && this.sale.instructions.length > 0)
    },
    instructionTotal() {
      if (!this.sale.instructions || this.sale.instructions.length === 0) return 0.00;
      let total = this.sale.instructions.map(i => i.Price).reduce((acc, n) => Number(n) + Number(acc))
      if (isNaN(total)) {
        return 0.00;
      }
      return Number(total.toFixed(2))
    },
    instructions() {
      return this.sale.instructions.map((int) => {
        int.Price = Number(int.Price.toFixed(2))
        return int;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.current-sale-line {
  padding: 15px; /* Adjusted padding */
  min-height: 95px;
  margin-bottom: 10px; /* Adjusted margin */
  background: var(--card-bg); /* Consistent background */
  border-radius: 10px; /* Consistent border-radius */
  box-shadow: var(--card-shadow-sm); /* Subtle shadow */
  transition: var(--transition-speed); /* Consistent transition */
  font-family: var(--font-family); /* Consistent font family */
  color: var(--text-primary); /* Default text color */

  &:hover {
    box-shadow: var(--card-shadow-hover); /* Enhanced hover shadow */
    background: var(--bg-primary-dark); /* Subtle highlight on hover */
  }

  .row {
    .line-description-pane {
      .line-description {
        font-size: 1.1rem; /* Slightly larger font */
        margin: 0;
        line-height: 1.4; /* Adjusted line height */
        font-weight: 600; /* Bolder font */
        color: var(--text-primary); /* Consistent text color */
      }

      .text-success {
        color: var(--success-color) !important; /* Use success color variable */
        font-size: 0.85rem; /* Consistent font size */
        font-weight: 500;
      }
    }

    .line-prices-pane {
      display: flex;
      flex-direction: column;
      justify-content: center; /* Center content vertically */
      align-items: flex-end; /* Align prices to the right */

      .price-label {
        font-size: 0.85rem; /* Consistent font size */
        margin: 0 0 5px 0; /* Adjusted margin */
        color: var(--text-secondary); /* Consistent text color */

        .line-price {
          font-size: 1.1rem; /* Slightly larger font */
          font-weight: 700;
          color: var(--text-primary); /* Consistent text color */
        }
      }
    }
  }
}

// Removed unused button style
/*
button {
  background-color: transparent;
}
*/

.cooking-instruction-list {
  list-style: none; /* Remove default list style */
  padding: 0; /* Remove default padding */
  margin-top: 10px; /* Add margin for separation */
  border-top: 1px solid var(--card-border); /* Separator line */
  padding-top: 10px; /* Padding above line */

  .cooking-instruction-list-item {
    font-size: 0.8rem; /* Consistent font size */
    font-weight: 500; /* Consistent font weight */
    text-transform: none; /* Remove uppercase */
    color: var(--text-secondary); /* Consistent text color */
    display: flex;
    justify-content: space-between;
    padding: 3px 0; /* Adjusted padding */

    span {
      font-weight: 600; /* Bolder for values */
      color: var(--text-primary); /* Primary text color for values */
    }
  }
}

.price-row {
  display: flex;
  flex-direction: column; /* Stack prices vertically */
  align-items: flex-end; /* Align prices to the right */
  width: 100%;
}

.text-sm{
  font-size: 12px;
}
#discount-btn {
  padding: 2px;
  border-radius: 5px;
}
</style>